import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { AvailableModules, Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import ItemCard from 'modules/processes/components/ItemWizard/components/ItemCard'
import type { SelectorProps } from 'modules/processes/lib/types'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const Selector = ({ title, description, identifier, onSelect }: SelectorProps) => {
  const { itemType } = useItemProvider()
  const [openUpgradeModal, setOpenUpgradeModal] = useState<boolean>(false)
  const { company } = useCurrentSession()
  const requestReason = company.subscription.isLegacy
    ? ValidReasons.MissingFeatureLegacy
    : ValidReasons.MissingFeature
  const { category } = useParams()

  const { featureAvailability, loading } = useFeatureAvailability(
    Features.processes_custom_email_action
  )

  const handleOpenUpgradeModal = () => {
    setOpenUpgradeModal(true)
    track(trackingEvents.processes.actionUpsellClicked, {
      category,
      identifier,
    })
  }

  const onClose = () => {
    track(trackingEvents.processes.actionUpsellClosed, {
      category,
      identifier,
    })
    setOpenUpgradeModal(false)
  }

  if (loading) return null

  return (
    <>
      <ItemCard
        title={title}
        description={description}
        onSelect={() => onSelect(identifier)}
        itemType={identifier}
        value={itemType}
        isUpgradeSelector={!featureAvailability.available}
        openUpgradeModal={handleOpenUpgradeModal}
      />
      {openUpgradeModal && (
        <UpsellingKit.ProductModal
          isOpen={openUpgradeModal}
          onClose={onClose}
          requestSource="Workflow send custom email action configuration"
          featureRequested={Features.processes_custom_email_action}
          moduleRequested={AvailableModules.processes}
          requestReason={requestReason}
          pageSource="custom_workflow"
        />
      )}
    </>
  )
}
